import { render, staticRenderFns } from "./CourseStudent.vue?vue&type=template&id=8d1e1188&scoped=true&"
import script from "./CourseStudent.vue?vue&type=script&lang=js&"
export * from "./CourseStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1e1188",
  null
  
)

export default component.exports